import type { RouteRecordRaw } from 'vue-router'
import AuthLayout from '@/features/auth/layouts/AuthLayout.vue'

export const authRoute: RouteRecordRaw = {
  path: '/auth',
  component: AuthLayout,
  meta: { authRoutes: true },
  redirect: { name: 'login' },
  children: [
    {
      name: 'login',
      path: 'login',
      component: async () => await import('./pages/LoginPage.vue'),
    },
    {
      name: 'recover-password',
      path: 'recover-password',
      component: async () => await import('./pages/RecoverPasswordPage.vue'),
    },
    {
      name: 'check-email',
      path: 'check-email',
      component: async () => await import('./pages/CheckEmailPage.vue'),
    },
  ],
}
